module.exports = __webpack_public_path__ + "assets/img/doctor001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctor001.png
// module id = 253
// module chunks = 0